import { cwslapi } from "../index";

// 获取官网数据排行榜 —— 排行榜
export const getWebRankList = (data) => { 
  return cwslapi({
    url: "/rank/getWebRankList",// 记录类型,1：充值，2：VIP，3：天梯排行，4：成就排行榜
    method: "post",
    data,
  });
};
